var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.loadingApp !== 1)?_c('div',{staticClass:"d-flex justify-space-around"},[_c('v-card',{staticClass:"pa-0",attrs:{"flat":"","width":"100%","max-width":"210mm","min-height":"297mm"}},[_c('span',{staticClass:"ma-2",domProps:{"innerHTML":_vm._s(_vm.messageHTML)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }